<template>
	<div class="formTabWrapper">
		<div class="formTabTableWrap">
			<div class="formTabTableWrap_top">
				<div class="formTabTableWrap_top-title">Driver files</div>
				<div class="formTabTableWrap_top-add">
					<v-btn
							@click="onOpenPopup" type="button"
							depressed
							class="mainBtn mainBtn-text"
					>
						<span class="btnIco"><svg-sprite icon-id="addItem" width="20" height="20"></svg-sprite></span>
						<span class="btnText">Add new file</span>
					</v-btn>
				</div>
			</div>
			<div class="formTabTableWrap_body">
				<no-info
						v-if="filesList && filesList.length <= 0"
						text="This driver has no uploaded documents."
				/>
				<main-table
						v-else
						padding="0"
						flag="driverFilesList"
						:headers="getHeaders"
						:listItems="filesList"
						:filtersList="{}"
						:is-hide-header="false"
						:items-per-page-amount="10"
						:pages="[ 10, 20, 50, 100, 200, 500, 'All' ]"
						@updateClickButton="onClickButton"
						@updateClickButtonItemIndex="onClickButtonItemIndex"
				></main-table>
			</div>

		</div>

		<file-popup
				v-if="isPopup"
				:fileType="fileType"
				@updateClose="onClose"
				@updateFilesList="onFilesList"
				@updateView="previewAction"
		></file-popup>

	</div>

</template>
<script>
import { mapActions, mapGetters } from "vuex";
// services
import FilePopup from "@/components/Maintenance/Drivers/DriversForm/FilePopup/FilePopup.vue";
import { driverFileTable } from "@/components/Accounting/CustomerInvoices/CustomerInvoicesCreate/defaultHeaders";
import NoInfo from "@/shared/NoInfo/NoInfo.vue";

export default {
	name: "FourthTab",
	components: {
		NoInfo,
		FilePopup
	},
	props: {
		files: Array,
		fileType: Array,
		getPermissionAction: Boolean
	},
	computed: {
		...mapGetters([
			'driversList',
		]),
		getHeaders() {
			return driverFileTable;
		}
	},
	data: () => ({
		downloadLink: null,
		filesList: [],
		isPopup: false,
		activeItem: null,
		activeItemIndex: null,
	}),
	methods: {
		...mapActions([ 'getDeleteFiles', 'getDriverDeleteFiles' ]),

		previewAction(file) {
			this.$emit('updatePreviewAction', file);
		},

		onOpenPopup() {
			this.isPopup = true;
		},

		onClose() {
			this.isPopup = false;
		},

		onFilesList(file) {
			this.filesList.push(file);
		},

		onClickButtonItemIndex(index) {
			this.activeItemIndex = index;
		},
		onClickButton({ key, item }) {
			this.activeItem = item;
			if (key === "eye") {
				const file = item.file || item.value;
				this.$emit('updatePreviewAction', file);
			}
			if (key === "delete") {
				const id = item.id;
				const idx = this.activeItemIndex;
				if (id) this.getDriverDeleteFiles({ id });
				this.filesList.splice(idx, 1);
				this.$emit('updateData', this.filesList);
			}
		},
	},
	mounted() {
		this.filesList = this.files;
	}
};
</script>

<style scoped lang="scss">
@import "@/assets/style/components/formTab/formTabTableWrap";
</style>
